import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CiNotification } from 'src/app/models/ci-notification';
import { Subscription } from 'rxjs';
import { BellNotificationService } from 'src/app/services/bell-notification.service';
import { UrlHelper } from 'src/app/helpers/urlHelper';
import { SignalRService } from 'src/app/services/signal-r.service';
import { BellNotificationChange } from 'src/app/models/bell-notification-change.model';



@Component({
  selector: 'app-bell-notification',
  templateUrl: './bell-notification.component.html',
  styleUrls: ['./bell-notification.component.scss'],
})
export class BellNotificationComponent implements OnInit, OnDestroy {

  notificationsActive: boolean = false;
  interval: any;
  notifications: CiNotification[] = [];
  notificationCount: number;
  notificationsLoading: boolean = true;

  reloadSubscription: Subscription;

  @Input() internalApp: boolean = false;
  @Input() urlShowAll: string = '/home/notifications'
  @Output() onChangeCount: EventEmitter<BellNotificationChange> = new EventEmitter<BellNotificationChange>();

  constructor(
    private notificationService: BellNotificationService,
    private router: Router,
    private signalRService: SignalRService
  ) { }

  ngOnInit(): void {
    this.reloadSubscription = this.notificationService.reloadNotifiactions.subscribe(() => {
      this.loadNotifications();
      this.getNotificationsCount();
    });
    this.getNotificationsCount();
    this.signalRService.notificationHubConnection.on('ReceiveMessageCount', (data: number) => {
      this.onChangeCount.emit({
        notificationCountOld: this.notificationCount,
        notificationCount: data
      } as BellNotificationChange);
      this.notificationCount = data;
    });
  }

  ngOnDestroy(): void {
    this.reloadSubscription.unsubscribe();
  }

  private getNotificationsCount() {
    this.notificationService.getNotificationsCount()
    .subscribe(count => {
      this.notificationCount = count;
    });
  }

  @HostListener('window:click', ['$event'])
  private click(event: Event) {
    if(event.composedPath().findIndex(x => (<HTMLElement>x).classList?.contains('prs-notifications-dropdown-trigger') || (<HTMLElement>x).classList?.contains('prs-notifications-dropdown')) === -1) {
      this.notificationsActive = false;
    }
  }

  bellClick() {
    this.notificationsActive = !this.notificationsActive;
    if (this.notificationsActive) {
      this.notificationsLoading = true;
      this.loadNotifications();
    }
  }

  loadNotifications() {
    this.notificationService.loadNotifications()
    .subscribe(notifications => {
      this.notifications = notifications;
      this.notificationsLoading = false;
    });
  }

  showAllNotifications() {
    this.notificationsActive = false;
    if(UrlHelper.isExternalUrl(this.urlShowAll)) {
      window.location.href = this.urlShowAll;
    } else {
      this.router.navigate([this.urlShowAll]);
    }
  }

  clearNotifications() {
    this.notificationsLoading = true;
    this.notifications.forEach(notification => {
      this.notificationService.sendNotificationSeen(notification.id)
      .subscribe(() => {
        this.notificationService.setReloadNotifiactions();
      });
    });
    setTimeout(() => {
      this.loadNotifications();
    }, 500);
  }

}
